import { computed, watch } from 'vue';
import { useQuery } from '@tanstack/vue-query';
import { useApi } from '@shopexperts/shared';

/**
 * Composable for fetching project value range options
 * 
 * TODO: Add endpoint definition to reviews-v2.expert.ts API file
 * Endpoint should be something like: GET /expert/project-value-ranges or GET /project-value-ranges
 * Expected response: Array of { id: number, label: string, from?: number, to?: number }
 */
export function useProjectValueRanges() {
  const api = useApi();

  const { data, isLoading, error } = useQuery({
    queryKey: ['project-value-ranges'],
    queryFn: async () => {
      return await api.expert.reviewsV2.getProjectValueRanges();
    },
    staleTime: 60 * 60 * 1000, // 1 hour - this data doesn't change often
    gcTime: 24 * 60 * 60 * 1000, // 24 hours
  });

  const ranges = computed(() => data.value || []);
  const isLoadingRanges = computed(() => isLoading.value);
  const rangesError = computed(() => error.value);

  watch(error, (newError: any) => {
    if (newError) {
      console.error('[useProjectValueRanges] Error:', newError);
    }
  });

  return {
    ranges,
    isLoadingRanges,
    rangesError,
  };
}



